import {loadingCompleted, loadingFailed, loadingStarted} from 'models/LoadingStateReduxActions';
import {getStore} from 'redux-stores/Store';
import * as net from 'util/Net';

import {getLoadingState} from './reduceLoadingState';

/**
 * Use the redux store's loading state information to determine if the given model needs to be
 * fetched, and fetch it if so.
 *
 * modelType and modelKey can be any strings that together identify the item being fetched.
 *
 * fetchFn should be a function returning a Promise (or promise-like object) that performs the
 * fetch.
 *
 * Note that this uses the global store for now to make it easier to use, but could be moved to have
 * the store provided explicitly if we want.
 */
export default async function fetchIfNecessary(
  modelType: string,
  modelKey: string,
  fetchFn: (() => Promise<void>) | (() => void)
): Promise<void> {
  if (!getLoadingState(getStore().getState().models.loadingState, modelType, modelKey)) {
    getStore().dispatch(loadingStarted(modelType, [modelKey]));
    try {
      await fetchFn();
    } catch (e) {
      if (net.isServerRequestError(e)) {
        getStore().dispatch(loadingFailed(modelType, [modelKey]));
      }
      throw e;
    }
    getStore().dispatch(loadingCompleted(modelType, [modelKey]));
  }
}
